import type { TipoReceita } from '@/shared/repositories/activeIngredients/activeIngredientsRepository'
import type { PrescriptionSignatureKind } from '@/shared/lib/digitalSignatureDocumentType'

/** Mapeia tipo_receita ANVISA → subtipo de assinatura digital na prescrição. */
export function mapTipoReceitaToSignatureKind(
  t: TipoReceita | null | undefined,
): PrescriptionSignatureKind | null {
  if (t === 'antimicrobiano') return 'prescription_antimicrobial'
  if (t === 'notificacao_a' || t === 'notificacao_b' || t === 'controle_especial') {
    return 'prescription_controlled'
  }
  if (t === 'simples' || t === 'isento') return 'prescription_simple'
  return null
}
